import React from 'react';

const ProblemSection = () => {
  return (
    <section className="section-padding bg-[var(--bg-secondary)]">
      <div className="container px-4 sm:px-10">
        <div className="max-w-3xl mx-auto text-center">
          {/* Section Label */}
          <p className="eyebrow-gold uppercase tracking-widest mb-6">
            The Real Problem
          </p>
          
          {/* Main Content */}
          <h2 className="heading-1 mb-8">
            Families don't lack insurance.
            <span className="block mt-2 text-[var(--text-secondary)]">They lack structure and assurance.</span>
          </h2>
          
          <div className="divider mx-auto mb-8"></div>
          
          <p className="body-large text-[var(--text-secondary)] mb-6">
            Many families already own policies — sometimes several.
          </p>
          
          <p className="body-regular text-[var(--text-secondary)] mb-6">
            But when you step back and ask deeper questions:
          </p>
          
          <p className="body-regular text-[var(--text-secondary)] mb-2">
            Is the coverage correctly aligned to income and responsibilities?<br />
            Are nominees and documentation clear?<br />
            Will your family know exactly what to do during a claim or crisis?
          </p>
          
          <p className="body-regular text-[var(--text-secondary)] mb-6 mt-6">
            Most families discover something uncomfortable:
          </p>
          
          <p className="body-large text-[var(--text-primary)] mb-6">
            They are over-insured in some areas, under-insured in others, and structurally unprepared overall.
          </p>
          
          <p className="body-regular text-[var(--text-secondary)] mb-8">
            The result is not peace of mind.
          </p>
          
          <p className="body-large text-[var(--text-primary)] mb-8">
            It is quiet uncertainty.
          </p>
          
          <div className="bg-[var(--bg-primary)] p-8 border border-[var(--border-light)]">
            <p className="body-large text-[var(--text-primary)] italic">
              "Protection Guardianship™ exists because families deserve certainty — not another sales pitch."
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;